// Pazaryeri İşlem Logları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.marketplaceLogs';

export const marketplaceLogsGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Pazaryeri İşlem Logları nasıl takip edilir?'),
  intro: t(`${G}.intro`, 'Bu ekran, pazaryeri entegrasyonlarına (N11) gönderilen işlemlerin durumunu takip etmeniz için hazırlanmıştır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  navItems: [
    t(`${G}.nav.all`, 'Tümü'),
    t(`${G}.nav.success`, 'Başarılı'),
    t(`${G}.nav.pending`, 'Beklemede'),
    t(`${G}.nav.failed`, 'Hatalı'),
  ],
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve toplu işlemler'),
    tabs: t(`${G}.regions.tabs`, 'Arama ve sekmeler'),
    body: t(`${G}.regions.body`, 'Log listesi'),
    footer: t(`${G}.regions.footer`, 'Kapat'),
  },
  steps: [
    {
      region: 'tabs',
      title: t(`${G}.s1.title`, '1. Sekmelerle durumu ayırın'),
      text: t(`${G}.s1.text`, 'Sekmelerden başarılı, bekleyen ve hatalı işlemleri ayrı ayrı izleyebilirsiniz; parantez içindeki sayı o durumdaki işlem adedidir. Arama kutusunda ürün adı, stok kodu veya task ID ile arayın.'),
      tips: [
        t(`${G}.s1.tip1`, 'Başarılı: N11 işlemi tamamladı. Beklemede: N11 hâlâ işliyor. Hatalı: N11 işlemi reddetti.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Log satırını açın'),
      text: t(`${G}.s2.text`, 'Her satırda durum, ürün, stok kodu, işlem tipi (Fiyat/Stok Güncelleme, Katalog Ürün Ekleme, Mevcut Ürün Gönderme), task numarası ve tarih görünür. Satıra tıklayınca işlem ayrıntıları ve N11\'den dönen sonuç (SKU durumu, fiyat, stok, red nedeni) açılır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Güncel durumu sorgulayın'),
      text: t(`${G}.s3.text`, 'Satırdaki yenile simgesi ("Task Detaylarını Kontrol Et") ile N11 tarafından dönen güncel durumu manuel olarak yenileyebilirsiniz. Başlıktaki "İşlemi Kontrol Et" düğmesi bekleyen tüm işlemleri tek seferde sorgular.'),
    },
    {
      region: 'header',
      title: t(`${G}.s4.title`, '4. Tamamlanan logları temizleyin'),
      text: t(`${G}.s4.text`, 'Başlıktaki "Tamamlanan Logu Temizle" düğmesi başarılı kayıtları listeden kaldırır. Böylece sadece aksiyon gerektiren kayıtları görünür tutarsınız.'),
      tips: [
        t(`${G}.s4.tip1`, 'Temizleme yalnız tamamlanan (başarılı) logları siler; bekleyen ve hatalı kayıtlar kalır.'),
      ],
    },
  ],
});
